const uploadAssetToMux = () => {};

export default uploadAssetToMux;
